// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { IconWrapper } from "@insite/mobius/Icon";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { productCompareFlyOutStyles } from "@synd/Overrides/Components/ProductCompareFlyOut";
import { productCarouselStyles } from "@synd/Overrides/Widgets/Common/ProductCarousel";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, ellipsis, layoutContainer, mergeWithCss, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

productCompareFlyOutStyles.cardWrapper = {
    css: css`
        position: relative;
        height: 100%;
    `,
};

productCompareFlyOutStyles.productMiniCardStyles = {
    ...mergeWithCss(productCarouselStyles.miniCardStyles, {
        productGridContainerStyles: {
            image: {
                css: css`
                    & [data-test-selector="productImage"] {
                        width: 72px;
                        height: 72px;
                        min-width: 72px;
                        max-width: 72px;
                        min-height: 72px;
                        max-height: unset;
                    }
                `,
            },
            container: {
                css: css`
                    gap: 8px;
                    grid-template-columns: 72px minmax(0, 1fr);
                    & > .bottom-section {
                        grid-row: 3 / 6;
                        grid-template-columns: 72px minmax(0, 1fr);
                    }
                    grid-template-rows: auto;
                `,
            },
            info: {
                css: css`
                    gap: 0;
                `,
            },
        },
        productDescriptionStyles: {
            productDetailSubDescription: {
                css: css`
                    ${ellipsis(2)};
                `,
            },
        },
    }),
};

productCompareFlyOutStyles.removeProductFromCompareButton = {
    css: css`
        position: absolute;
        top: 0;
        right: 10px;
        &:hover {
            ${IconWrapper}, svg {
                color: ${color("common.ui9")};
            }
        }
    `,
};

productCompareFlyOutStyles.carouselDrawer = {
    position: "bottom",
    cssOverrides: {
        drawerTitle: css`
            color: ${color("text")};
            background: ${color("common.white")};
        `,
        drawerBody: css`
            background: ${color("common.white")};
        `,
    },
    closeButtonProps: {
        css: css`
            display: none;
        `,
    },
    enableClickThrough: true,
};

productCompareFlyOutStyles.carouselDrawerContainer = {
    css: css`
        ${layoutContainer}
        ${xScreen("lte", "sm")} {
            display: none;
        }
    `,
};

productCompareFlyOutStyles.swiperStyles = {
    container: {
        css: css`
            .swiper-wrapper {
                margin-left: 10px;
            }
            & .swiper-slide > div {
                height: 100%;
            }
        `,
    },
};

productCompareFlyOutStyles.headerGridContainer = {
    gap: 0,
    isFullWidth: true,
    css: css`
        ${layoutContainer}
    `,
};

productCompareFlyOutStyles.headerCompareButton = {
    typographyProps: {
        size: 11,
        lineHeight: fontConfig.xxSmall.lineHeight,
    },
    css: css`
        margin: 5px 11px 5px 5px;
        min-height: 26px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
};

productCompareFlyOutStyles.headerRemoveAllButton = {
    typographyProps: {
        size: 11,
        lineHeight: fontConfig.xxSmall.lineHeight,
    },
    css: css`
        margin: 5px;
        min-height: 26px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        flex: 1;
                    `,
                ],
                "max",
            )}
    `,
    variant: "secondary",
};
